const SimpleTimePickerActivityXMl =
    `<?xml version="1.0" encoding="utf-8"?>
<androidx.constraintlayout.widget.ConstraintLayout 
    xmlns:android="http://schemas.android.com/apk/res/android"
    xmlns:app="http://schemas.android.com/apk/res-auto"
    xmlns:tools="http://schemas.android.com/tools"
    android:layout_width="match_parent"
    android:layout_height="match_parent"
    tools:context=".MainActivity">

    <LinearLayout
        android:layout_width="match_parent"
        android:layout_height="wrap_content"
        android:orientation="vertical"
        app:layout_constraintBottom_toBottomOf="parent"
        app:layout_constraintEnd_toEndOf="parent"
        app:layout_constraintStart_toStartOf="parent"
        app:layout_constraintTop_toTopOf="parent">

        <TextView
            android:id="@+id/timeTxt"
            android:layout_width="match_parent"
            android:layout_height="wrap_content"
            android:textAlignment="center"
            android:textSize="16sp" />

        <Button
            android:id="@+id/simpleTimePickerBtn"
            android:layout_width="match_parent"
            android:layout_height="wrap_content"
            android:layout_margin="8dp"
            android:text="Simple Time Picker" />
    </LinearLayout>
</androidx.constraintlayout.widget.ConstraintLayout>`

const SimpleTimePickerActivityKT =
    `package com.example

import android.annotation.SuppressLint
import android.app.TimePickerDialog
import android.os.Bundle
import android.widget.Button
import android.widget.TextView
import androidx.appcompat.app.AppCompatActivity
import java.text.DecimalFormat
import java.text.NumberFormat
import java.util.*


class MainActivity : AppCompatActivity() {

    @SuppressLint("SetTextI18n")
    override fun onCreate(savedInstanceState: Bundle?) {
        super.onCreate(savedInstanceState)
        setContentView(R.layout.activity_main)
        
        // todo: Simple time picker code
        findViewById<TextView>(R.id.timeTxt).text = "--:--"
        val mTimePicker: TimePickerDialog
        val mCurrentTime = Calendar.getInstance()
        val hour = mCurrentTime.get(Calendar.HOUR_OF_DAY)
        val minutes = mCurrentTime.get(Calendar.MINUTE)

        mTimePicker = TimePickerDialog(this,
            { _, hourOfDay, minute ->
                val modifiedHour = getHourAMPM(hourOfDay)
                val pmAm = if (hourOfDay > 11) "PM" else "AM"
                val f: NumberFormat = DecimalFormat("00")
                findViewById<TextView>(R.id.timeTxt).text =
                    f.format(modifiedHour).toString() + ":" + f.format(minute).toString() + pmAm

            }, hour, minutes, false
        )

        findViewById<Button>(R.id.simpleTimePickerBtn).setOnClickListener {
            mTimePicker.show()
        }
        // todo: Simple time picker code

    }

    private fun getHourAMPM(hour: Int): Int {
        // Return the hour value for AM PM time format
        var modifiedHour = if (hour > 11) hour - 12 else hour
        if (modifiedHour == 0) {
            modifiedHour = 12
        }
        return modifiedHour
    }
}`

module.exports = {
    SimpleTimePickerActivityXMl: SimpleTimePickerActivityXMl,
    SimpleTimePickerActivityKT: SimpleTimePickerActivityKT
};
